import { Modal, Button } from 'react-bootstrap';
import '../base-less/modal.less';

export class ModalGeneralComposted extends React.Component {
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal: false,
    };
  }

  handleHide() {
    this.setState({ showModal: false });
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  render() {
    return (
      <div id="modal-wrap-alert-modal modalInnerContent">
        <div className="modal-container">
          <Modal
            show={this.state.showModal}
            container={this.props.container}
            onHide={this.handleHide}
            bsSize="large"
            backdrop="static"
            aria-labelledby="contained-modal-title-lg"
          >
            <Modal.Header>
              <Modal.Title>{this.props.MessageTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div
                className={
                  this.props.TypeModal + ' col-xs-12 col-sm-12 col-md-12 col-lg-12 modal-error-body modalInnerContent'
                }
              >
                <div className="col-xs-12 col-sm-10 col-md-10 col-lg-10 right-error-modal modalInnerContent">
                  {this.props.msg}
                </div>
              </div>
              <div className={this.props.TypeModal + ' inner-Model-buttons modalInnerContentButton'}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 text-left">
                  <Button
                    className={
                      this.props.TextBtnTres === '' ? 'none' : this.props.TypeModal + ' btn btn-default visible-xs last'
                    }
                    onClick={() => {
                      this.handleHide();
                      this.props.BtnTresAction();
                    }}
                  >
                    {this.props.TextBtnTres}
                  </Button>
                  <Button
                    className={
                      this.props.TextBtnUno === '' ? 'none' : this.props.TypeModal + ' btn btn-link hidden-xs first'
                    }
                    onClick={() => {
                      this.handleHide();
                      this.props.BtnUnoAction();
                    }}
                  >
                    {this.props.TextBtnUno}
                  </Button>
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 text-center">
                  <Button
                    className={
                      this.props.TextBtnTres === '' && this.props.TextBtnUno === ''
                        ? this.props.TypeModal + ' btn btn-default middle'
                        : this.props.TypeModal + ' btn btn-primary middle '
                    }
                    onClick={() => {
                      if (!this.props.noclose) {
                        this.handleHide();
                      }
                      this.props.BtnDosAction();
                    }}
                  >
                    {this.props.TextBtnDos}
                  </Button>
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 text-right">
                  <Button
                    className={
                      this.props.TextBtnTres === '' ? 'none' : this.props.TypeModal + ' btn btn-default hidden-xs last'
                    }
                    onClick={() => {
                      this.handleHide();
                      this.props.BtnTresAction();
                    }}
                  >
                    {this.props.TextBtnTres}
                  </Button>
                  <Button
                    className={
                      this.props.TextBtnUno === '' ? 'none' : this.props.TypeModal + ' btn btn-link visible-xs first'
                    }
                    onClick={() => {
                      this.handleHide();
                      this.props.BtnUnoAction();
                    }}
                  >
                    {this.props.TextBtnUno}
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ModalGeneralComposted;
